var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayerBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 33,
    viewBox: "0 0 30 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0539474 3.94266C-0.0812067 1.63722 2.33004 0.0500098 4.39419 1.08568L27.6159 12.737C29.68 13.7727 29.849 16.6545 27.92 17.9243L6.21877 32.2092C4.28977 33.4789 1.70958 32.1843 1.57443 29.8789L0.0539474 3.94266Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerBtn);
export default __webpack_public_path__ + "static/media/player-btn.7165d898ecf15ad3753efc5bb35d1e64.svg";
export { ForwardRef as ReactComponent };